import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { cancelEvaluationByType, resetGenieParams } from '../redux/genie/genieReducer';
import {
  generateAlternate,
  generateMessages,
  getGenieAudiences,
  getGenieBrandOptions,
  getGenieData,
  predictResponse,
  replyGenie,
  resetSession,
} from '../redux/genie/genieActions';
import PredictResponse from './components/predict-response/PredictResponse';
import GenerateMessages from './components/generate-messages/GenerateMessages';
import { uploadFile } from '../redux/scout/scoutActions';
import { GENIE_EVALUATE_TYPE, PROJECT_TYPES } from '../constants';
import CommonPage from '../components/common-page/CommonPage';

import scss from './Genie.module.scss';

function Genie() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const handlePredictResponse = (values) => {
    dispatch(predictResponse({ values, projectId: id }));
  };

  const handleGenerateAlternate = (values) => {
    dispatch(generateAlternate({ values, projectId: id }));
  };

  useEffect(() => {
    if (id) {
      dispatch(getGenieData({ id }));
      dispatch(getGenieBrandOptions());
      dispatch(getGenieAudiences({ projectId: id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResetSession = () => {
      dispatch(resetSession());
    };

    window.addEventListener('beforeunload', handleResetSession);

    return () => {
      window.removeEventListener('beforeunload', handleResetSession);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(cancelEvaluationByType(GENIE_EVALUATE_TYPE.ALTERNATE));
      dispatch(cancelEvaluationByType(GENIE_EVALUATE_TYPE.GENERATED));
      dispatch(resetSession());
      dispatch(resetGenieParams());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommonPage className={scss.pageWrapper}>
      <PredictResponse onPredictResponse={handlePredictResponse} onGenerateAlternate={handleGenerateAlternate} />

      <GenerateMessages
        onGenerateMessages={generateMessages}
        onReply={replyGenie}
        onResetSession={resetSession}
        onFileUpload={uploadFile}
        projectType={PROJECT_TYPES.GENIE}
      />
    </CommonPage>
  );
}

export default Genie;
